module.exports = __webpack_public_path__ + "static/media/creativo.0f10de35.jpg";